import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  text-align: left;
  margin-bottom: 50px;

  p {
    color: ${key('colors.black.default')};
  }

  ${media.moreThan('smPlus')`
    display: flex;
    flex-direction: row;

    > div {
      flex: 0 0 50%;

      &:first-child {
        padding-right: 20px;
      }

      &:last-child {
        padding-left: 20px;
      }
    }

    p {
      font-size: 16px;
      line-height: 22px;
    }
  `};
`;
